import { Breadcrumbs as _Breadcrumbs } from './Breadcrumbs'
import { RouteBreadcrumbs } from './RouteBreadcrumbs'

export * from './types'
export * from './RouteBreadcrumbs'

type BreadcrumbsWithRoute = {
  Route: typeof RouteBreadcrumbs
} & typeof _Breadcrumbs
;(_Breadcrumbs as BreadcrumbsWithRoute).Route = RouteBreadcrumbs

const Breadcrumbs = _Breadcrumbs as BreadcrumbsWithRoute
export { Breadcrumbs }
